/**
 * Profile view. Shows message flyout
 */

import $ from 'jquery'
import _ from 'lodash'
import View from 'view/view'
import dataProvider from 'service/data_provider'
import windowView from 'shared/view/window'

import PopoverView from 'component/popover/popover'
import MessageFlyoutView from 'component/header/view/message_flyout'

import TwinklesCollection from 'component/header/collection/twinkles'
import ConversationsCollection from 'component/header/collection/conversations'

import CounterBadgeView from 'component/counter/badge'
import CounterModel from 'component/counter/model/counter'

import alertCounter from 'shared/model/alert_counter'
import experiment from 'service/experiment'

const MessageView = View.extend({
    _popover: null,
    _collection: null,

    events: {
        'click .js-flyout-trigger': 'toggle',
    },

    initialize() {
        // initialize subviews once
        this._initPopover = _.once(this._initPopover)

        alertCounter.fetch()
        const getMessageAlertCount = () =>
            alertCounter.get('unreadMessageCount') +
            alertCounter.get('unseenTwinkleCount') +
            alertCounter.get('pendingContactRequestCount')

        const listenToChanges = [
            'change:unreadMessageCount',
            'change:unseenTwinkleCount',
            ...['change:pendingContactRequestCount'],
        ]

        const counterModel = new CounterModel({
            maxCount: 99,
            count: getMessageAlertCount(),
        })

        this.listenTo(alertCounter, listenToChanges.join(' '), () => counterModel.set('count', getMessageAlertCount()))

        this._collection = {
            twinkles: new TwinklesCollection(),
            conversations: new ConversationsCollection(),
        }

        // set collection initial state
        this._collection.twinkles.setState('total', dataProvider.get('unseenTwinkleCount'))
        this._collection.conversations.setState('unreadCount', dataProvider.get('unreadConversationCount'))

        this.initSubview(CounterBadgeView, {
            el: this.$('.js-message-notification-count'),
            model: counterModel,
        }).render()
    },

    toggle() {
        this._popover = this._initPopover().toggle()
    },

    close() {
        if (this._popover) {
            this._popover.close()
        }
    },

    _initPopover() {
        let extraClasses = 't-headerMessageFlyout popover-header popover-headerMessageFlyout'

        if (windowView.isBelowMaxPageWidth()) {
            extraClasses += ' popover-headerBelowDesktop'
        }

        return this.initSubview(
            PopoverView,
            {
                name: 'messageFlyout',
                el: this.$('.js-flyout-trigger'),
                content: this._initFlyout().el,
                extraClasses,
                preset: 'navigationalDropdown',
            },
            { remove: false }
        )
    },

    _initFlyout() {
        this._collection.twinkles.fetch()
        this._collection.conversations.fetch()

        return this.initSubview(
            MessageFlyoutView,
            {
                // Notice: global selector, content is outside of the current element
                // inside of the general header popover's content placeholder
                el: $('.js-header-messageFlyout'),

                twinklesCollection: this._collection.twinkles,
                conversationsCollection: this._collection.conversations,
            },
            { remove: false }
        )
    },
})

export default MessageView
